import { Injectable } from '@angular/core';
import QRCode from 'qrcode';

export type QrOptions = {
  errorCorrectionLevel?: 'L' | 'M' | 'Q' | 'H';
  margin?: number;
  scale?: number;
  darkColor?: string;
  lightColor?: string;
};

@Injectable({ providedIn: 'root' })
export class QrCodeService {
  async generateJoinDataUrl(code: string, opts?: QrOptions): Promise<string> {
    const joinUrl = this.buildJoinUrl(code);
    return await this.generateDataUrl(joinUrl, opts);
  }

  getCodeFromJoinUrl(url: string): string | null {
    try {
      const parsedUrl = new URL(url);
      if (parsedUrl.protocol !== 'caldevo:') return null;
      if (parsedUrl.hostname !== 'join') return null;
      return parsedUrl.searchParams.get('code');
    } catch {
      return null;
    }
  }

  private async generateDataUrl(
    value: string,
    opts?: QrOptions
  ): Promise<string> {
    const errorCorrectionLevel = opts?.errorCorrectionLevel ?? 'M';
    const margin = opts?.margin ?? 1;
    const scale = opts?.scale ?? 6;
    const dark = opts?.darkColor ?? '#000000';
    const light = opts?.lightColor ?? '#ffffff';

    return await QRCode.toDataURL(value, {
      errorCorrectionLevel,
      margin,
      scale,
      color: { dark, light },
    });
  }

  private buildJoinUrl(code: string): string {
    return `caldevo://join?code=${encodeURIComponent(code)}`;
  }
}
